export const TOAST_AUTOCLOSE_DELAY_IN_MS = 5000;
